import React from 'react';

// The tasting room: a short passage and a menu-style price list. Prices are set
// here; bottle prices vary by wine, so that row points to the wine list below.
const PRICES = [
  { name: 'Tasting Flight', note: 'A one-ounce pour of each of our nine wines', price: '$10' },
  { name: 'By the Glass', note: 'Red or white', price: '$10' },
  { name: 'By the Bottle', note: 'Any wine, opened to enjoy on the premises', link: { href: '#wines', text: 'See prices below' } }
];

function TastingRoom() {
  return (
    <section id="tastings" className="py-10 px-4 bg-beige">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-5xl font-bold mb-4 text-wine relative pb-6 section-divider">The Tasting Room</h2>
        <div className="space-y-6 mt-12 text-lg text-gray-600">
          <p>Our wines are best discovered where they are made. Step into our rustic tasting room, or relax on the patio overlooking the vineyard. A great place to begin is with a tasting flight: a one-ounce pour of each of our nine estate wines, from our dry whites through our barrique-aged reds to our dessert wine.</p>
          <p>When you find the one you love, stay a while. Enjoy a glass of red or white, or open a bottle to share. Every wine we make is available by the bottle to enjoy here, and each bottle pours about four glasses, the perfect way to spend an afternoon with friends.</p>
        </div>

        <ul className="price-list max-w-xl mx-auto mt-12 text-left">
          {PRICES.map(item => (
            <li key={item.name} className="py-5">
              <div className="flex items-baseline">
                <h3 className="text-2xl text-wine">{item.name}</h3>
                <span className="price-leader" aria-hidden="true" />
                {item.link ? (
                  <a href={item.link.href} className="text-lg italic text-wine underline whitespace-nowrap hover:text-gold-dark" style={{ fontFamily: "'Playfair Display', serif" }}>{item.link.text}</a>
                ) : (
                  <span className="text-2xl text-wine whitespace-nowrap" style={{ fontFamily: "'Playfair Display', serif" }}>{item.price}</span>
                )}
              </div>
              <p className="text-gray-600 italic mt-1">{item.note}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default TastingRoom;
